import React from 'react';
import styles from './Banner.module.scss';
import { Icon } from 'lmc-ui-library';

export type API = {
  content?: string;
};

type Props = {
  handleBannerVisibility: () => void;
} & API;

const Banner: React.FC<Props> = ({ handleBannerVisibility, content }) => {
  return (
    <div className={styles.bannerContainer}>
      <div>
        <div className={styles.title}>
          <Icon type="accept" color="#007B88" />
          <div className={styles.titleText}>Success</div>
        </div>
        <div>{content}</div>
      </div>
      <button onClick={handleBannerVisibility} className={styles.closeButton}>
        <Icon type="close" color="#3A4451" />
      </button>
    </div>
  );
};

export default Banner;
